.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-3) var(--gutter);
  border-bottom: 1px solid var(--rule);
  background: var(--surface);
  min-width: 0;
}

/*
 * Sticky against the pane it is in, which is `main` or one of the SplitView's
 * two panes. Both are bounded scroll containers, which is the only reason this
 * works: `position: sticky` in a document that scrolls as a whole measures
 * against the viewport and slides away with the rows.
 *
 * `--z-sticky` and not a higher layer. It has to sit over the rows scrolling
 * beneath it and under every menu opened from inside it.
 */
.sticky {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

/*
 * Between the filters and the actions, and it takes the slack. Putting the
 * count here rather than under the table means it is next to the controls that
 * changed it, where somebody who has just filtered is already looking.
 */
.summary {
  flex: 1 1 auto;
  font: var(--type-micro);
  font-variant-numeric: var(--numeric);
  color: var(--text-muted);
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-left: auto;
}
